import NewsletterSignup from '@homeaway/react-newsletter-signup';
import PropTypes from 'prop-types';
import React from 'react';
import {asyncComponent} from 'react-async-component';

import './Newsletter.less';

// TODO: Sort out how to property test and cover the asyncComponent
export const AsyncNewsletterSignup = asyncComponent({
    serverMode: 'defer',
    resolve: /* istanbul ignore next */() => Promise.resolve(NewsletterSignup),
});

const getMessages = (data) => ({
    buttonLabel: data.buttonLabel,
    failure: data.failure,
    info: data.info,
    inputLabel: data.inputLabel,
    invalidEmail: data.invalidEmail,
    success: data.success,
});

const Newsletter = (props) => {
    if (!props.data) {
        return null;
    }

    const {
        endpointUrl,
    } = props.data;
    const message = getMessages(props.data);

    return (
        <div className="SiteFooter__newsletter">
            <AsyncNewsletterSignup
                dataUrl={endpointUrl}
                i18n={message}
                site={props.site}
                source={'react-site-footer'}
            />
        </div>
    );
};

Newsletter.propTypes = {
    className: PropTypes.string,
    data: PropTypes.shape({
        buttonLabel: PropTypes.string,
        endpointUrl: PropTypes.string,
        failure: PropTypes.string,
        info: PropTypes.string,
        inputLabel: PropTypes.string,
        invalidEmail: PropTypes.string,
        success: PropTypes.string,
    }),
    site: PropTypes.string.isRequired,
};

export default Newsletter;
